import { IconButton, ShareIcon } from '@ui/kit';
import { courseBuilderStore } from '../../state/store.js';
import { jsx } from 'react/jsx-runtime';

function ShareAction(props) {
  return /*#__PURE__*/jsx(IconButton, {
    icon: /*#__PURE__*/jsx(ShareIcon, {}),
    label: "Del forl\xF8b",
    onClick: evt => {
      evt.stopPropagation();
      props.onClick?.();
      courseBuilderStore.dispatch(courseBuilderStore.actions.selectCourseById(props.course.id));
      courseBuilderStore.dispatch(courseBuilderStore.actions.toggleShareDrawer(true));
      courseBuilderStore.dispatch(courseBuilderStore.actions.togglePanel(true));
    }
  });
}

export { ShareAction };
//# sourceMappingURL=actions.share.js.map
